// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qmZGh","questions":"styles_questions___KaUN","footer":"styles_footer__Jpwbs"};